import React from 'react';
import { bool, number } from 'prop-types';
import classNames from 'classnames';
import FormGigItem from '../../shared/FormGigItem';

import './style.scss';

const BooleanPricingFactor = ({ id, included, packageId, customized = false }) => (
    <td className={classNames('boolean-pricing-factor', { included })}>
        {
            customized && <FormGigItem packageId={packageId} id={id} quantity={1}/>
        }
    </td>
);

BooleanPricingFactor.propTypes = {
    included: bool,
    customized: bool,
    id: number,
    packageId: number
};

export default BooleanPricingFactor;
